<template>
    <div class="body-style" >
        <v-form ref="form" @submit.prevent="submit" class="h-100">
            <v-row justify="center" class="mx-2">
                <v-col cols="12" class="pb-0">
                    <div class="w-100 d-flex justify-center my-2">
                        <div class="logo-circle d-flex justify-center align-center">
                            <img :src="whiteLogo" contain width="auto" height="120" />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                        label="اسم المستخدم"
                        v-model="userName"
                        class="rounded-BigLg"
                        solo
                        hide-details
                        :disabled="submitLoading"
                    />
                </v-col>
                <v-col cols="12"  sm="6">
                    <v-text-field
                        label="كلمة المرور"
                        v-model="password"
                        class="rounded-BigLg"
                        color=""
                        hide-details
                        id="Password"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        solo
                        :disabled="submitLoading"
                    />
                </v-col>
                <v-col cols="12" class="d-flex justify-center mt-2">
                    <v-btn type="submit" color="secondary" :loading="submitLoading" class="rounded-BigLg">تسجيل الدخول</v-btn>
                </v-col>

                <v-col cols="12" class="d-flex flex-column justify-center align-center">
                    <!-- رابط المدرسة -->
                    <span class="my-2 white--text"> تابع نشاطاتنا على </span>
                    <v-btn
                        type="submit"
                        color="white"
                        elevation="2"
                        outlined
                        class="text-none rounded-fa "
                        :href="schoolFacebookPage"
                        target="_blank"
                    >
                        Facebook
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <div class="d-flex justify-end align-start mb-2">
            <v-bottom-navigation v-model="navigationBottom" color="primary" width="70" height="auto" class="elevation-0" >
                <a href="https://www.facebook.com/edunix.system" target="_blank">
                    <v-img src="@/assets/Powered By Edunix (Black).png" width="50" />
                </a>
            </v-bottom-navigation>
        </div>
    </div>
</template>

<script>
import { whiteLogo, schoolFacebookPage } from '@/config/config.js'
import { busTripType } from '@/helper/enums'
export default {
    name: 'LoginView',
    components: {
    },

    data: () => ({
        userName: '',
        password: '',
        showPassword: false,
        submitLoading: false,
        navigationBottom: true,
        whiteLogo,
        schoolFacebookPage
    }),

    methods: {
        submit () {
            if ((this.userName !== null && this.userName !== '') && (this.password !== null && this.password !== '')) {
                this.submitLoading = true
                this.$store.dispatch('auth/loginCore', {
                    username: this.userName,
                    password: this.password
                }).then(() => this.$store.dispatch('auth/fetchBusProfile')).then((bus) => {
                    // the bus already has a trip running - pick it back up instead of
                    // showing the start-trip screen (which would only 409)
                    if (!bus.tripId) {
                        this.$store.dispatch('transport/clearTripId')
                        this.$router.replace({ name: 'choose-page' })
                        return
                    }

                    return this.$store.dispatch('transport/resumeTrip', { tripId: bus.tripId }).then((tripType) => {
                        this.$router.replace({
                            name: 'student-page',
                            query: { isStart: tripType !== busTripType.return }
                        })
                    })
                }).catch((error) => {
                    this.$eventBus.$emit('show-snackbar', 'اسم المستخدم أو كلمة المرور غير صحيحة', error)
                }).finally(() => {
                    this.submitLoading = false
                })
            } else {
                return null
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
.body-style {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: $background-color;
    border-bottom-left-radius: 165px;
    padding-top: 40px;
}
.rounded-fa {
    border-radius: 12px;
}
.logo-circle {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: white;
}
</style>
